export default "__VITE_ASSET__CcF$ftjU__"